export default "__VITE_ASSET__BpF5kKdB__"